// OnSports content constants — single source of truth

export const BRAND = {
  name: "OnSports",
  legalName: "OnSports S.r.l.",
  tagline: "Impact Sports Consultancy",
  email: "hello@weareonsports.com",
  phone: "+39 320 3231925",
  addressStreet: "Via Jacopo Dal Verme, 7",
  addressCity: "20159 — Milano (MI)",
  address: "Via Jacopo Dal Verme, 7 — 20159 Milano (MI)",
  vat: "P.IVA 11367080964",
  sdi: "Codice destinatario: M5UXCR1",
  capital: "Capitale sociale: 10.000 € i.v.",
};

export const LOGOS = {
  blueWordmark: "/images/brand/blue-wordmark.png",
  greenLogo: "/images/brand/green-logo.png",
  greenWordmark: "/images/brand/green-wordmark.png",
  whiteLogo: "/images/brand/white-logo.png",
  whiteWordmark: "/images/brand/white-wordmark.png",
};

export const NAV = [
  { label: "Home", href: "/" },
  { label: "Servizi", href: "/servizi" },
  { label: "Works", href: "/works" },
  { label: "About", href: "/about" },
  { label: "Join the Team", href: "/join-the-team" },
  { label: "News", href: "/news" },
];

export const SOCIAL = [
  { label: "Instagram", icon: "Instagram", href: "https://www.instagram.com/weare_onsports/" },
  { label: "LinkedIn", icon: "Linkedin", href: "https://www.linkedin.com/company/weareonsports/" },
  { label: "Facebook", icon: "Facebook", href: "https://www.facebook.com/weareonsports" },
];

export const PILLARS = [
  {
    num: "01",
    title: "Business Impact",
    body:
      "Crescita economica documentabile. ROI tracciato, lead qualificati, pipeline commerciale, riduzione CAC, aumento LTV. Trasformiamo sponsorship da \u201ccosto necessario\u201d a leva di crescita con metriche che parlano al CFO.",
  },
  {
    num: "02",
    title: "Cultural Impact",
    body:
      "Narrazioni che cambiano percezioni. Lo sport è un amplificatore culturale unico. Usiamo storytelling strategico e format proprietari per elevare brand, spostare percezioni e conquistare share of voice nel settore.",
  },
  {
    num: "03",
    title: "Social Impact",
    body:
      "CSR autentica, non di facciata. Co-progettiamo iniziative che generano cambiamento reale e documentabile. Framework di misurazione che soddisfano i requisiti ESG più stringenti. Beneficiari tracciati, comportamenti modificati.",
  },
];

export const SERVICES = [
  {
    slug: "impact-strategy-advisory",
    num: "01",
    title: "Impact Strategy & Advisory",
    short: "Consulenza strategica per C-level. Business case e roadmap che convincono il board.",
    headline: "Strategia che convince il board",
    body:
      "Consulenza di alto livello per C-level, responsabili marketing e CSR manager. Costruiamo business case, roadmap strategiche e framework di misurazione per investimenti nello sport.",
    items: [
      "Sport Impact Strategy Program — analisi contesto, definizione strategia, roadmap trimestrale con KPI sui 3 pilastri",
      "Sponsorship Impact Optimizer — revisione portafogli esistenti, benchmark competitivo, piano ottimizzazione ROI",
      "Fractional Sport Impact CMO — leadership strategica senior in outsourcing",
      "Marketing Check-Up & Piano Marketing — audit completo e costruzione piano operativo",
    ],
    cta: "Richiedi una consulenza strategica",
  },
  {
    slug: "sponsorship-impact-programs",
    num: "02",
    title: "Sponsorship & Impact Programs",
    short: "Da \u201clogo su maglia\u201d a piattaforme integrate con KPI chiari.",
    headline: "Sponsorship che generano valore, non solo visibilità",
    body:
      "Trasformiamo sponsorship da \u201clogo su maglia\u201d a piattaforme integrate di business, contenuti e CSR. Non singole attivazioni spot ma programmi annuali con KPI chiari.",
    items: [
      "Progettazione platform sponsorship end-to-end",
      "Activation plan annuali con matchday, contenuti, fan engagement",
      "CSR & Sport Impact Project — co-progettazione iniziative CSR misurabili",
      "Framework di misurazione dell'impatto su business, cultura, società",
    ],
    cta: "Ripensa le tue sponsorship",
  },
  {
    slug: "content-ip-studio",
    num: "03",
    title: "Content & IP Studio",
    short: "Contenuti premium e format proprietari che sono asset strategici.",
    headline: "Contenuti che sono asset, non costi",
    body:
      "Creiamo contenuti premium e format proprietari che non sono \u201csolo belli\u201d ma cambiano percezioni. IP editoriali licenziabili che diventano riferimenti culturali nel settore.",
    items: [
      "Sport Excellence Media Suite — storytelling premium, produzione completa, testimonial, eventi",
      "Sport Activation Media Suite — hero video + clip social + foto professionali",
      "Format editoriali originali replicabili e licenziabili",
      "Progetti con creator e atleti per distribuzione verticale",
    ],
    cta: "Crea contenuti che lasciano il segno",
  },
  {
    slug: "pitchpartner",
    num: "04",
    title: "Tech & Data – PitchPartner",
    short: "Software SaaS per gestione sponsorship.",
    headline: "La tecnologia al servizio delle sponsorship",
    body:
      "PitchPartner è il nostro software SaaS proprietario per club, leghe e federazioni. Gestione end-to-end delle sponsorship: contratti, attivazioni, reporting, networking B2B tra sponsor.",
    items: [
      "Piano Basic — entry per club Serie B/C",
      "Piano Premium — per club A1/B con analytics avanzate",
      "Piano Elite — white-label con account manager dedicato",
    ],
    cta: "Scopri PitchPartner",
  },
  {
    slug: "research-insight",
    num: "05",
    title: "Research, Data & Insight",
    short: "Intelligence strategica e report ESG.",
    headline: "Decisioni basate su dati, non su intuizioni",
    body:
      "Ricerca proprietaria e intelligence strategica per decisioni evidence-based. Report utilizzabili per bilanci ESG e comunicazione istituzionale.",
    items: [
      "Sports Impact Report Corporate Edition — ricerca personalizzata per bilanci ESG",
      "Sports Impact Observatory — osservatorio trimestrale trend investimenti",
      "Fan Engagement & Data Analysis — analisi comportamentale per ottimizzazione strategie",
    ],
    cta: "Accedi alla nostra ricerca",
  },
  {
    slug: "performance-marketing-growth",
    num: "06",
    title: "Performance Marketing & Growth",
    short: "Lead generation e conversioni tracciabili.",
    headline: "Dallo sport alle conversioni",
    body:
      "Collegamento tra strategie sport e risultati commerciali: lead generation, funnel automation, campagne ADV con ROI tracciabile.",
    items: [
      "Sport Performance & Growth Program — gestione marketing completo con ADV, funnel, CRM",
      "Campagne Meta, Google, LinkedIn ottimizzate per conversione",
      "Lead generation per operatori locali con pricing performance-based",
    ],
    cta: "Genera lead qualificati",
  },
];

export const VALUES = [
  {
    num: "01",
    title: "Impatto prima di tutto",
    body: "Ogni progetto deve generare impatto misurabile. Se non possiamo documentare risultati concreti, non lo facciamo.",
  },
  {
    num: "02",
    title: "Qualità > Volume",
    body: "Preferiamo fare 10 progetti eccellenti che 50 mediocri. La reputazione è l'asset più prezioso.",
  },
  {
    num: "03",
    title: "Partnership, non fornitura",
    body: "Relazioni di medio-lungo termine. Co-creazione di progetti, non esecuzione a chiamata.",
  },
  {
    num: "04",
    title: "Trasparenza totale",
    body: "KPI chiari, reporting leggibile, scorecard condivise. Nessun fumo, solo dati.",
  },
  {
    num: "05",
    title: "Innovazione continua",
    body: "Framework proprietari, IP editoriali, tech SaaS. Il mercato cambia, noi lo anticipiamo.",
  },
];

export const WORK_VALUES = [
  { num: "01", title: "Ownership totale", body: "Ogni progetto ha un responsabile, non un esecutore." },
  { num: "02", title: "Apprendimento continuo", body: "Framework proprietari, metodologie in evoluzione." },
  { num: "03", title: "Qualità non negoziabile", body: "Preferiamo dire no che fare lavori mediocri." },
  { num: "04", title: "Collaborazione vera", body: "Siamo un team piccolo dove tutti contano." },
];

export const JOBS = [
  {
    title: "Business Developer",
    location: "Milano · Hybrid",
    category: "Commerciale",
    chi: "La persona che vogliamo incontrare ha un forte orientamento commerciale e consulenziale, nutre una passione autentica per lo sport e il marketing, è propositiva, relazionale e orientata al valore. Cerchiamo un Business Developer con approccio consulenziale, capace di sviluppare relazioni e opportunità di valore, non solo vendite spot.",
    ruolo: "Il Business Developer è responsabile dello sviluppo commerciale dei servizi, lavorando a stretto contatto con il team strategico per proporre soluzioni coerenti, sostenibili e ad alto impatto.",
    responsabilita: [
      "Sviluppare opportunità commerciali su brand e aziende sport-attive",
      "Condurre call di discovery e qualificazione con prospect e lead",
      "Costruire proposte consulenziali insieme a strategist e consultant",
      "Gestire il processo di vendita fino al closing e onboarding del cliente",
      "Sviluppare partnership strategiche nel mondo sportivo e corporate",
    ],
    mansioni: [
      "Prospecting e outreach mirato su target aziendali definiti",
      "Gestione e nurturing del pipeline commerciale tramite CRM",
      "Preparazione di presentazioni commerciali e pitch personalizzati",
      "Partecipazione a eventi, fiere e momenti di networking nel mondo sport e marketing",
      "Coordinamento con il team interno per la definizione delle proposte di valore",
      "Reportistica periodica sulle attività commerciali e sui risultati raggiunti",
      "Identificazione di opportunità di upsell e cross-sell sui clienti esistenti",
    ],
    richiediamo: [
      "Esperienza di almeno 2 anni in business development o vendita consulenziale",
      "Capacità di dialogare con decisori aziendali e stakeholder di alto livello",
      "Approccio strutturato, orientato al valore e alla relazione di medio-lungo termine",
      "Autonomia, senso di responsabilità e orientamento al risultato",
      "Conoscenza del mercato sportivo e/o del marketing digitale",
      "Conoscenza e applicazione dell'AI nelle attività lavorative quotidiane",
    ],
    plus: [
      "Esperienza pregressa nel settore sport, sponsorship o marketing",
      "Network consolidato nel mondo corporate e/o sportivo",
      "Capacità di pianificazione, sintesi e follow-up",
      "Buone doti organizzative e comunicative",
      "Voglia di imparare e di migliorarsi costantemente",
      "Conoscenza della lingua inglese",
      "Disponibilità a trasferte occasionali di breve e medio raggio",
    ],
  },
  {
    title: "Senior Consultant / Fractional CMO",
    location: "Milano · Hybrid",
    category: "Strategy & Advisory",
    chi: "La persona che vogliamo incontrare ha una solida esperienza in marketing strategico e consulenza, una visione ampia del business e una passione profonda per lo sport come leva di cambiamento. Cerchiamo un Senior Consultant / Fractional CMO che affianchi i clienti nelle scelte strategiche, diventando un riferimento su sport, sponsorship, marketing e impact.",
    ruolo: "È una figura di guida e responsabilità, orientata alle decisioni e alla direzione strategica, non all'operatività quotidiana. Lavora con clienti strutturati e contribuisce a definire il posizionamento e la crescita dei loro investimenti nello sport.",
    responsabilita: [
      "Condurre assessment e workshop strategici con i clienti",
      "Definire obiettivi, KPI e roadmap di marketing sportivo",
      "Supervisionare progetti di sport marketing, sponsorship e CSR",
      "Fornire advisory continuativa per clienti strutturati",
      "Supportare la crescita dei progetti nel medio-lungo periodo",
    ],
    mansioni: [
      "Analisi dello scenario competitivo e delle opportunità strategiche per i clienti",
      "Progettazione di piani di marketing integrato sport-centred",
      "Presentazione di raccomandazioni strategiche a C-level e board aziendali",
      "Coordinamento con il team per garantire coerenza tra strategia e delivery",
      "Partecipazione a meeting con i clienti per la revisione dei risultati e la ridefinizione delle priorità",
      "Mentoring e supporto alla crescita delle figure junior del team",
    ],
    richiediamo: [
      "Esperienza di almeno 3 anni in marketing strategico, consulenza o ruoli direzionali",
      "Capacità di lavorare a livello decisionale con stakeholder senior",
      "Visione di business e orientamento ai risultati misurabili",
      "Leadership, credibilità professionale e capacità di ispirare fiducia",
      "Conoscenza e applicazione dell'AI nelle attività lavorative quotidiane",
    ],
    plus: [
      "Esperienza pregressa in sport marketing, sponsorship o settori affini",
      "Capacità di gestione di progetti complessi e multi-stakeholder",
      "Ottime doti di comunicazione e presentazione",
      "Attitudine imprenditoriale e proattiva",
      "Conoscenza della lingua inglese",
      "Disponibilità a trasferte occasionali",
    ],
  },
  {
    title: "Project Manager",
    location: "Milano · Hybrid",
    category: "Operations",
    chi: "La persona che vogliamo incontrare ha ottime capacità organizzative e di coordinamento, nutre una passione per lo sport e per la gestione di progetti complessi, è precisa, affidabile e orientata alla qualità. Cerchiamo un Project Manager che garantisca ordine, controllo e qualità nell'esecuzione dei progetti.",
    ruolo: "Il PM è il punto di raccordo tra strategia, delivery e cliente, assicurando che ogni progetto venga consegnato nei tempi e con gli standard previsti. È una figura centrale nel funzionamento della consultancy.",
    responsabilita: [
      "Pianificare e coordinare i progetti dall'avvio alla chiusura",
      "Gestire team interni e fornitori esterni garantendo qualità e tempi",
      "Mantenere la relazione operativa con il cliente durante tutto il ciclo di vita del progetto",
      "Controllare tempi, scope e qualità dei deliverable",
      "Condurre retrospettive e chiusura ordinata dei progetti",
    ],
    mansioni: [
      "Definizione di timeline, milestones e allocazione risorse per ogni progetto",
      "Coordinamento quotidiano con il team di lavoro e i fornitori",
      "Gestione delle piattaforme di project management e della documentazione di progetto",
      "Comunicazione periodica con il cliente sullo stato di avanzamento",
      "Identificazione e gestione proattiva di rischi e criticità",
      "Partecipazione ai meeting interni per lo start-up di nuovi progetti",
      "Produzione di report di progetto e supporto alla fatturazione",
    ],
    richiediamo: [
      "Esperienza di almeno 2 anni in project management (marketing, consulenza o agency)",
      "Ottime capacità organizzative e comunicative",
      "Attitudine alla gestione di più progetti in parallelo",
      "Orientamento alla responsabilità e al risultato",
      "Conoscenza e applicazione dell'AI nelle attività lavorative quotidiane",
      "Flessibilità e attitudine a lavorare in un contesto dinamico",
    ],
    plus: [
      "Familiarità con strumenti di project management (Asana, Monday, Notion o simili)",
      "Attitudine al lavoro in team e autonomia negli incarichi personali",
      "Buone doti di problem solving e gestione delle priorità",
      "Voglia di imparare e di migliorarsi costantemente",
      "Orientamento alla soddisfazione del cliente",
      "Conoscenza della lingua inglese",
      "Disponibilità a trasferte occasionali di breve e medio raggio",
    ],
  },
  {
    title: "Data Analyst — Sport, Sponsorship & Impact",
    location: "Milano · Hybrid",
    category: "Research, Data & Insight",
    chi: "La persona che vogliamo incontrare ha ottime capacità analitiche, nutre una forte passione per lo sport e per i dati, è curiosa, precisa e orientata al risultato. Cerchiamo un Data Analyst che voglia contribuire in modo concreto alle decisioni strategiche, trasformando dati complessi in insight chiari per clienti e team interni.",
    ruolo: "Il Data Analyst lavora trasversalmente sui progetti, supportando servizi di strategia, sponsorship, activation, media e performance. È una figura chiave per rendere misurabile l'impatto delle attività e per migliorare continuamente qualità ed efficacia dei progetti.",
    responsabilita: [
      "Analizzare dati provenienti da campagne media, contenuti, sponsorship, fanbase e funnel per produrre insight strategici",
      "Costruire dashboard e report periodici a supporto dei servizi",
      "Sviluppare modelli di misurazione per sponsorship, CSR e activation",
      "Supportare strategist, consultant e business development con dati e analisi",
      "Monitorare costantemente le performance per ottimizzare la strategia e massimizzare i risultati",
    ],
    mansioni: [
      "Raccolta, pulizia e analisi di dati da fonti eterogenee (social, adv, CRM, analytics)",
      "Creazione e aggiornamento di dashboard dinamiche (Google Data Studio, Looker, Power BI)",
      "Produzione di report mensili di impatto per i clienti",
      "Analisi di benchmark, competitor e trend di mercato",
      "Supporto alla costruzione di KPI e scorecard per i progetti",
      "Partecipazione ai meeting interni e con i clienti per la presentazione dei risultati",
      "Collaborazione continua con il team per allineamento e aggiornamento sui progetti",
    ],
    richiediamo: [
      "Esperienza di almeno 2 anni in data analysis, marketing analytics o ruoli affini",
      "Capacità di lavorare con più fonti dati e sintetizzarle in modo chiaro e visuale",
      "Attitudine data-driven orientata al business e ai risultati",
      "Capacità di presentare risultati a interlocutori non tecnici in modo efficace",
      "Conoscenza e applicazione dell'AI nelle attività lavorative quotidiane",
      "Ottime doti comunicative, capacità di lavorare in team e problem solving",
    ],
    plus: [
      "Conoscenza di Google Analytics, Google Tag Manager e strumenti di web analytics",
      "Familiarità con strumenti di data visualization (Data Studio, Power BI, Tableau)",
      "Conoscenza base di SQL e/o Python per data analysis",
      "Attitudine al lavoro in team e autonomia negli incarichi personali",
      "Buone doti organizzative e voglia di imparare e migliorarsi",
      "Orientamento alla soddisfazione del cliente",
      "Conoscenza della lingua inglese",
      "Passione per il mondo dello sport",
    ],
  },
];

export const JOB_AREAS = [
  "Commerciale",
  "Strategy & Advisory",
  "Operations",
  "Research, Data & Insight",
  "Content & IP",
  "Performance Marketing",
  "Altro",
];

export const WORKS = [
  {
    title: "OnSports × Vero Volley",
    category: "Cultural Impact · Content & IP Studio",
    subtitle: "Numia Vero Volley Milano — Una stagione vissuta da dentro",
    kpis: ["Gold Partner", "Reportage Finale Scudetto 2025/26"],
    tone: "dodgers",
    to: "/works/vero-volley",
    image: "/images/works/vero-volley/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "Volleyball World Italia",
    category: "Cultural Impact · Social & Content",
    subtitle: "FIVB Volleyball World — Una community costruita da zero",
    kpis: ["Da 0 a 121K+ follower", "7,16% engagement rate"],
    tone: "dodgers",
    to: "/works/volleyball-world-italia",
    image: "/images/works/volleyball-world-italia/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "AC Milan Connect",
    category: "Business Impact · Strategy & Performance",
    subtitle: "AC Milan × Afinna One — Dalla sponsorship al prodotto",
    kpis: ["1° club al mondo con SIM dedicata", "1.000+ SIM vendute al lancio (organico)"],
    tone: "dodgers",
    to: "/works/ac-milan-connect",
    image: "/images/works/ac-milan-connect/hero.jpg",
    pillar: "Business Impact",
    services: ["Performance Marketing & Growth"],
  },
  {
    title: "Empower",
    category: "Business Impact · Brand Creation & Performance",
    subtitle: "Biolife — Brand identity end-to-end per una linea sport recovery",
    kpis: [
      "1.000+ kit venduti nel primo mese",
      "ROAS 236% su email & Meta Ads",
    ],
    tone: "dodgers",
    to: "/works/empower",
    image: "/images/works/empower/hero.jpg",
    pillar: "Business Impact",
    services: ["Performance Marketing & Growth"],
  },
  {
    title: "Protek",
    category: "Business Impact · Brand & Performance",
    subtitle:
      "In-house project — Un brand DTC di guanti da portiere, da zero al mercato",
    kpis: [
      "1.500+ paia vendute in 6 mesi",
      "+262% ROAS Meta Ads",
    ],
    tone: "dodgers",
    to: "/works/protek",
    image: "/images/works/protek/hero.jpg",
    pillar: "Business Impact",
    services: ["Performance Marketing & Growth"],
  },
  {
    title: "LVF TV",
    category: "Business Impact · Subscriber Acquisition",
    subtitle: "Lega Volley Femminile — Una stagione, una piattaforma, dieci mila abbonati",
    kpis: [
      "10.000+ abbonati raggiunti",
      "ROI Black Friday +1.926%",
    ],
    tone: "dodgers",
    to: "/works/lvf-tv",
    image: "/images/works/lvf-tv/hero.jpg",
    pillar: "Business Impact",
    services: ["Performance Marketing & Growth"],
  },
  {
    title: "Scuola Attiva",
    category: "Social Impact · Content",
    subtitle: "Sport e Salute × MIM — Lanciare il più grande progetto di sport scolastico italiano",
    kpis: ["11.000+ scuole", "1,5M+ studenti raggiunti"],
    tone: "dodgers",
    to: "/works/scuola-attiva",
    image: "/images/works/scuola-attiva/hero.gif",
    pillar: "Social Impact",
    services: ["Sponsorship & Impact Programs"],
  },
  {
    title: "Mizuno – Reach Beyond",
    category: "Business Impact · Content & Performance",
    subtitle: "Mizuno — Dal training alla conversione",
    kpis: [
      "4 azzurri Campioni del Mondo · 1 sales page",
      "Concept + Content + Performance integrati",
    ],
    tone: "dodgers",
    to: "/works/mizuno-reach-beyond",
    image: "/images/works/mizuno-reach-beyond/hero.gif",
    pillar: "Business Impact",
    services: ["Sponsorship & Impact Programs"],
  },
  {
    title: "Your Next Level — Chieri '76",
    category: "Cultural Impact · Brand Journalism",
    subtitle: "Reale Mutua Assicurazioni — Da Chieri a Timisoara, un'Europa",
    kpis: [
      "1° trofeo europeo del Chieri '76",
      "Reportage editoriale end-to-end",
    ],
    tone: "dodgers",
    to: "/works/reale-mutua-your-next-level",
    image: "/images/works/reale-mutua-your-next-level/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Sponsorship & Impact Programs"],
  },
  {
    title: "Sportlinx360",
    category: "Business Impact · Lead Generation & Content",
    subtitle: "Sportlinx360 — Borse di studio US college per atleti italiani",
    kpis: [
      "2.500+ lead qualificati in 3 anni",
      "Meta + Google Ads · Creator volley · Email Marketing",
    ],
    tone: "dodgers",
    to: "/works/sportlinx360",
    image: "/images/works/sportlinx360/thumbnail.jpg",
    pillar: "Business Impact",
    services: ["Performance Marketing & Growth", "Content & IP Studio"],
  },
  {
    title: "Extra Ordinary",
    category: "Social Impact · Content & IP",
    subtitle: "Credem Banca — Un van, tre tappe, un piccolo extra",
    kpis: [
      "3 tappe · 4 azzurri testimonial",
      "Social responsibility project end-to-end",
    ],
    tone: "dodgers",
    to: "/works/credem-extra-ordinary",
    image: "/images/works/credem-extra-ordinary/hero.jpg",
    pillar: "Social Impact",
    services: ["Sponsorship & Impact Programs", "Content & IP Studio"],
  },
  {
    title: "Nike × JD Sports",
    category: "Cultural Impact · Content & Performance",
    subtitle: "Nike × JD Sports UK — La Vapormax torna virale",
    kpis: [
      "#NIKEVAPORMAXCHALLENGE · 623K+ impressions",
      "Filtro 3D AR con TikTok Creative Lab",
    ],
    tone: "dodgers",
    to: "/works/nike-jd",
    image: "/images/works/nike-jd/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "Reale Mutua × La Giornata Tipo",
    category: "Social Impact · Charity Activation",
    subtitle: "Reale Mutua Basket Torino — #BTogetherforUkraine",
    kpis: [
      "460K+ impressions · 2K+ click",
      "Raccolta fondi per bambini ucraini con cancro",
    ],
    tone: "dodgers",
    to: "/works/reale-mutua-together-for-ukraine",
    image: "/images/works/reale-mutua-together-for-ukraine/hero.jpg",
    pillar: "Social Impact",
    services: ["Content & IP Studio", "Sponsorship & Impact Programs"],
  },
  {
    title: "Essere Libero",
    category: "Cultural Impact · Content & IP",
    subtitle: "Reale Mutua × Chieri '76 — Una sponsorship dentro un format",
    kpis: ["590K+ impressions · 19K+ interazioni", "3 canali di amplificazione integrati"],
    tone: "dodgers",
    to: "/works/reale-mutua-essere-libero",
    image: "/images/works/reale-mutua-essere-libero/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "Prada × America's Cup 36",
    category: "Cultural Impact · Image Coordinata & IP",
    subtitle: "Prada — La 36ª America's Cup, Auckland 2021",
    kpis: [
      "170 anni di tradizione, grammatica visiva nuova",
      "Video · App · Village · Merchandising",
    ],
    tone: "dodgers",
    to: "/works/prada-americas-cup",
    image: "/images/works/prada-americas-cup/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "Mizuno × Valentina Zago",
    category: "Cultural Impact · Brand Legacy",
    subtitle:
      "Reach Beyond, episodio Zago — Ritratto editoriale di una decennale partnership",
    kpis: [
      "590K+ impressions · 19K+ interazioni",
      "10+ anni di partnership Mizuno-Zago",
    ],
    tone: "dodgers",
    to: "/works/mizuno-valentina-zago",
    image: "/images/works/mizuno-valentina-zago/hero.gif",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "Noleggiare × Hellas Verona",
    category: "Cultural Impact · Brand Experience",
    subtitle: "Noleggiare · Hellas Verona · Infront — Dal logo all'esperienza",
    kpis: ["Attivazione phygital end-to-end", "Matchday Hellas-Milan al Bentegodi"],
    tone: "dodgers",
    to: "/works/noleggiare-hellas",
    image: "/images/works/noleggiare-hellas/hero.jpg",
    pillar: "Cultural Impact",
    services: ["Sponsorship & Impact Programs", "Content & IP Studio"],
  },
  {
    title: "Kappa × Coop",
    category: "Cultural Impact · Content & Performance",
    subtitle: "Coop Lombardia × Kappa — Sport inizia con K",
    kpis: ["623K+ impressions TikTok", "34K+ interazioni"],
    tone: "dodgers",
    to: "/works/kappa-x-coop",
    image: "/images/works/kappa-x-coop/hero.gif",
    pillar: "Cultural Impact",
    services: ["Content & IP Studio"],
  },
  {
    title: "Problemi di Volley",
    category: "Cultural Impact · Property OnSports",
    subtitle: "Problemi di Volley — La community madre, l'IP di OnSports",
    kpis: [
      "Property OnSports · 290K+ follower community",
      "Lungolinea + Casa Cisolla × Credem",
    ],
    tone: "dodgers",
    to: "/works/problemi-di-volley",
    image: "/images/works/problemi-di-volley/hero.jpg",
    year: "2019 — In corso",
    pillar: "Cultural Impact",
    pillarsSecondary: ["Business Impact"],
    services: ["Content & IP Studio", "Sponsorship & Impact Programs"],
  },
];

export const NEWS = [
  {
    title: "Il vecchio modello di sponsorship è morto. Cosa lo sostituisce.",
    category: "Editoriale",
    date: "12 Gen 2026",
    excerpt: "Tre cambiamenti strutturali stanno ridefinendo cosa significa investire nello sport. Spoiler: non c'entra la reach.",
    featured: true,
  },
  { title: "Sports Impact Observatory – Q4 2025", category: "Research", date: "08 Gen 2026", excerpt: "Trend, benchmark e segnali deboli dagli investimenti delle aziende italiane nello sport." },
  { title: "Perché chiamiamo i nostri clienti \u201cpartner\u201d", category: "Cultura", date: "02 Gen 2026", excerpt: "Una scelta semantica che cambia tutto: dal preventivo allo scorecard." },
  { title: "PitchPartner: il SaaS per chi gestisce sponsorship", category: "Prodotto", date: "20 Dic 2025", excerpt: "Cosa fa, a chi serve, e perché ci siamo stancati di file Excel da 47 tab." },
  { title: "ESG e sport: oltre la facciata", category: "Editoriale", date: "12 Dic 2025", excerpt: "Quattro errori che vediamo ripetersi nei report di bilancio sostenibilità del 2025." },
  { title: "Misurare l'impatto culturale: si può davvero?", category: "Method", date: "01 Dic 2025", excerpt: "Tre framework che usiamo per documentare quello che le \u201creach\u201d non vedono." },
];

export const MARQUEE_WORDS = [
  "BUSINESS IMPACT",
  "CULTURAL IMPACT",
  "SOCIAL IMPACT",
  "BUSINESS IMPACT",
  "CULTURAL IMPACT",
  "SOCIAL IMPACT",
];

export const CLIENTS = [
  { name: "Sport e Salute", logo: "/images/home/logos/sport-e-salute.png" },
  { name: "Reale Mutua", logo: "/images/home/logos/reale-mutua.png" },
  { name: "Credem", logo: "/images/home/logos/credem.png" },
  { name: "LVF — Lega Volley Femminile", logo: "/images/home/logos/lvf.png" },
  { name: "AC Milan", logo: "/images/home/logos/ac-milan.png" },
  { name: "Coop", logo: "/images/home/logos/coop.png" },
  { name: "Hellas Verona FC", logo: "/images/home/logos/hellas-verona.png" },
  { name: "Rise — Sustainability for Sport", logo: "/images/home/logos/rise.png" },
  { name: "Gieffe Racing", logo: "/images/home/logos/gieffe-racing.png" },
  { name: "Kappa", logo: "/images/home/logos/kappa.png" },
  { name: "Afinna One", logo: "/images/home/logos/afinna-one.png" },
  { name: "Sportlinx 360", logo: "/images/home/logos/sportlinx-360.png" },
  { name: "YouCoach", logo: "/images/home/logos/youcoach.png" },
  { name: "Noleggiare", logo: "/images/home/logos/noleggiare.png" },
  { name: "Mizuno", logo: "/images/home/logos/mizuno.png" },
  { name: "Volleyball World", logo: "/images/home/logos/volleyball-world.png" },
  { name: "America's Cup", logo: "/images/home/logos/americas-cup.png" },
  { name: "Nike", logo: "/images/home/logos/nike.png" },
  { name: "JD", logo: "/images/home/logos/jd.png" },
  { name: "Momentum", logo: "/images/home/logos/momentum.png" },
];

export const PARTNERS = [
  { name: "Vero Volley", logo: "/images/home/partners/vero-volley.png", tight: true },
  { name: "Vamos! — Sport Activation Partner", logo: "/images/home/partners/vamos.png" },
  { name: "Infront", logo: "/images/home/partners/infront.png" },
  { name: "Kora", logo: "/images/home/partners/kora.png" },
];

export const ESIGENZE = [
  "Strategia",
  "Sponsorship",
  "Contenuti",
  "Tech",
  "Research",
  "Performance",
];
